export default __webpack_public_path__ + "static/media/multicar9.d7d4d7aa.jpeg";